<template>
  <section class="work-flow">
    <div class="work-flow__container default-content">

      <h2 class="section-title">
        {{ locales?.pages?.how_it_works || '' }}
      </h2>

      <div class="work-flow__tabs" v-if="false">
        <a
          class="work-flow__tabs-item"
          :class="termValue === 0 ? 'work-flow__tabs-item--active' : ''"
          href="#"
          @click.prevent="changeTermValue(0)"
        >
          {{ locales?.pages?.long_term_rent || '' }}
        </a>

        <a
          class="work-flow__tabs-item"
          :class="termValue === 1 ? 'work-flow__tabs-item--active' : ''"
          href="#"
          @click.prevent="changeTermValue(1)"
        >
          {{ locales?.pages?.short_term_booking || '' }}
        </a>
      </div>

      <!-- LONG TERM -->
      <div class="work-flow__list">

        <div class="work-flow__list-item">
          <div class="work-flow__list-header">
            <div class="work-flow__list-image-holder">
              <i class="icon-search"></i>
            </div>

            <h3 class="work-flow__list-title">
              {{ page?.long_term_1_title_lang?.[lang] || '' }}
            </h3>
          </div>

          <p
            class="work-flow__list-text"
            v-if="page?.long_term_1_content_lang?.[lang]"
            v-html="page.long_term_1_content_lang[lang]"
          ></p>
        </div>

        <div class="work-flow__list-item">
          <div class="work-flow__list-header">
            <div class="work-flow__list-image-holder">
              <i class="icon-upload"></i>
            </div>

            <h3 class="work-flow__list-title">
              {{ page?.long_term_2_title_lang?.[lang] || '' }}
            </h3>
          </div>

          <p
            class="work-flow__list-text"
            v-if="page?.long_term_2_content_lang?.[lang]"
            v-html="page.long_term_2_content_lang[lang]"
          ></p>
        </div>

        <div class="work-flow__list-item">
          <div class="work-flow__list-header">
            <div class="work-flow__list-image-holder">
              <i class="icon-approved"></i>
            </div>

            <h3 class="work-flow__list-title">
              {{ page?.long_term_3_title_lang?.[lang] || '' }}
            </h3>
          </div>

          <p
            class="work-flow__list-text"
            v-if="page?.long_term_3_content_lang?.[lang]"
            v-html="page.long_term_3_content_lang[lang]"
          ></p>
        </div>

      </div>

      <!-- SHORT TERM (currently hidden in your original logic, preserved) -->
      <div class="work-flow__list" v-if="false">

        <div class="work-flow__list-item">
          <div class="work-flow__list-header">
            <div class="work-flow__list-image-holder">
              <i class="icon-search"></i>
            </div>

            <h3 class="work-flow__list-title">
              {{ page?.short_term_1_title_lang?.[lang] || '' }}
            </h3>
          </div>

          <p
            class="work-flow__list-text"
            v-if="page?.short_term_1_content_lang?.[lang]"
            v-html="page.short_term_1_content_lang[lang]"
          ></p>
        </div>

        <div class="work-flow__list-item">
          <div class="work-flow__list-header">
            <div class="work-flow__list-image-holder">
              <i class="icon-upload"></i>
            </div>

            <h3 class="work-flow__list-title">
              {{ page?.short_term_2_title_lang?.[lang] || '' }}
            </h3>
          </div>

          <p
            class="work-flow__list-text"
            v-if="page?.short_term_2_content_lang?.[lang]"
            v-html="page.short_term_2_content_lang[lang]"
          ></p>
        </div>

        <div class="work-flow__list-item">
          <div class="work-flow__list-header">
            <div class="work-flow__list-image-holder">
              <i class="icon-approved"></i>
            </div>

            <h3 class="work-flow__list-title">
              {{ page?.short_term_3_title_lang?.[lang] || '' }}
            </h3>
          </div>

          <p
            class="work-flow__list-text"
            v-if="page?.short_term_3_content_lang?.[lang]"
            v-html="page.short_term_3_content_lang[lang]"
          ></p>
        </div>

      </div>

      <a :href="link" class="theme-btn theme-btn--primary">
        {{ locales?.pages?.create_tenant_account || '' }}
        <i class="icon-go-right"></i>
      </a>

    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    page: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: "nl"
    },
    link: {
      type: String,
      default: "#"
    }
  },

  computed: {
    ...mapGetters(["locales"]),

    termValue() {
      return this.$store.state.term.termValue;
    }
  },

  methods: {
    changeTermValue(value) {
      this.$store.commit("CHANGE_TERM_VALUE", value);
    }
  }
};
</script>